import {connect} from 'react-redux';
import types from 'prop-types';

export {ROLES} from '../../constants';

export const RequiresRole = ({userRole, roles = [], children}) => {
  if (roles.indexOf(userRole) === -1) {
    return null;
  }

  return children || null;
};

RequiresRole.propTypes = {
  roles: types.array,
  userRole: types.string.isRequired,
};

const mapStateToProps = state => {
  return {
    userRole: state.identity.user.role,
  };
};

export default connect(mapStateToProps)(RequiresRole);
